import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsNameDescriptions, GoalStatus } from '_api/types';

export const GET_GOAL_STATUS = 'get-goal-status';

export const useGetGoalStatus = () =>
  useGetQuery<ConstantsNameDescriptions<GoalStatus>[]>(
    () => `/constant/status`,
    {},
    [GET_GOAL_STATUS],
    {
      refetchOnWindowFocus: false,
    },
  );
